@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/post-cards-4x6/the-woods-post-card-stack-content/the-woods-product-info-section/the-woods-product-info-section.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
.product-info-section {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.3125rem;
  justify-content: flex-start;
  align-items: flex-start;
}
.product-info-section .product-info-title {
  font-family: "alternate-gothic-no-3-d", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1rem;
  letter-spacing: 0.02rem;
  text-transform: uppercase;
  line-height: 100%;
}
.product-info-section .product-info {
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  font-style: normal;
  font-size: 0.625rem;
  letter-spacing: -0.025rem;
  overflow: clip;
  overflow-clip-margin: 0.09rem;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  word-break: break-word;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}
/*# sourceMappingURL=the-woods-product-info-section.component.css.map */
